// @flow

import createApiModule from "../create-api-module";

const { reducer, actions } = createApiModule(
    "categories",
    () => `/ays-series-event-management/categories?page=0&size=30`,
);

export const load = () => (dispatch: *) => {
    return dispatch(actions.load());
};

export const refetch = actions.refetch;
export const clear = actions.clear;
export default reducer;
